var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getJson, withOptional } from '@rad/utility/http';
const asDataUri = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
});
// An image from the app's own address, as a data URI a canvas can draw into a PNG; null when there is
// none. The response is a file, so its body is read as bytes where getJson would parse JSON.
export const getImageDataUri = (url) => withOptional((c, m) => getJson(url)(c, (mappings) => m(Object.assign(Object.assign({}, mappings), { 200: (res) => __awaiter(void 0, void 0, void 0, function* () { return asDataUri(yield res.blob()); }) }))));
